module.exports = __webpack_public_path__ + "de9194ef437f94ee1260f279d83fa05d.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/coldstart-per-language.png
// module id = 254
// module chunks = 1